interface BrandBadgeProps {
  name: string;
  color?: string;
  className?: string;
}

export function BrandBadge({ name, color, className = '' }: BrandBadgeProps) {
  const bg = color || '#64748b';
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium text-white ${className}`}
      style={{ backgroundColor: bg }}
    >
      {name}
    </span>
  );
}
